module.exports = __webpack_public_path__ + "v1.2.5.20250227/img/sub_icon.625dc846.png";